// extracted by mini-css-extract-plugin
export default {"header_box":"index_header_box_z2zPj","header":"index_header_G60WC clearfix"};